'use client';

import { useClipboard } from '@common/hooks';
import { SvgPhoneFill, SvgPin } from '@common/icon';

import { PageNavigation } from '@/components/client';

interface HeaderProps {
  title: string;
  address: string;
  tel: string;
  emergencyTel: string;
}

export const Header = ({ address, tel, emergencyTel, title }: HeaderProps) => {
  const copy = useClipboard();

  return (
    <header className="flex flex-col gap-16 pb-28 pt-20">
      <PageNavigation />
      <h1 className="font-600 typo-h6">{title}</h1>
      <ul className="flex flex-col gap-8">
        <li className="flex gap-8 typo-body4 ">
          <SvgPin className="mt-4 size-14 text-Gray-500" />
          <address className="flex-1 not-italic text-Gray-800">
            {address}
            <button
              className="ml-4 text-B-500 hover:underline"
              type="button"
              onClick={() => {
                copy({
                  message: '주소를 복사했어요',
                  value: address,
                });
              }}
            >
              복사
            </button>
          </address>
        </li>
        <li className="flex items-center justify-start text-Gray-800 typo-body4">
          <SvgPhoneFill className="mr-8 size-14 text-Gray-500" /> {tel}
          <button
            className="ml-4 text-B-500 hover:underline"
            type="button"
            onClick={() => {
              copy({
                message: '전화번호를 복사했어요',
                value: tel,
              });
            }}
          >
            복사
          </button>
        </li>
        {emergencyTel ? (
          <li className="pl-22 text-Gray-800 typo-body4">
            {emergencyTel} (응급실)
            <button
              className="ml-4 text-B-500 hover:underline"
              type="button"
              onClick={() => {
                copy({
                  message: '전화번호를 복사했어요',
                  value: emergencyTel,
                });
              }}
            >
              복사
            </button>
          </li>
        ) : null}
      </ul>
    </header>
  );
};
